import React from "react";
import Modal from "./Modal";
import Icon from "./Icon";

export default function ConfirmModal({
  isOpen = true,
  title = "Confirm Action",
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "danger", // "danger" | "warning" | "primary"
  loading = false,
  width = 440,
  onConfirm,
  onClose,
  children,
}) {
  if (!isOpen) return null;

  const iconName = variant === "danger" ? "alert" : variant === "warning" ? "alert" : "info";
  const iconColor = variant === "danger" ? "#DC2626" : variant === "warning" ? "#D97706" : "#1D4ED8";
  const btnClass = variant === "danger" ? "btn-danger" : variant === "warning" ? "btn-warning" : "btn-primary";

  return (
    <Modal title={title} onClose={onClose} width={width}>
      <div className="confirm-modal-body">
        <div className="confirm-icon-row">
          <div className={`confirm-icon-box confirm-icon-box--${variant}`}>
            <Icon name={iconName} size={20} color={iconColor} />
          </div>
          <div className="confirm-content">
            {message && <p className="confirm-message">{message}</p>}
            {children}
          </div>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn-secondary"
            onClick={onClose}
            disabled={loading}
          >
            {cancelText}
          </button>
          <button
            type="button"
            className={btnClass}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Processing..." : confirmText}
          </button>
        </div>
      </div>
    </Modal>
  );
}
